import { englishFormattedEuroCurrency } from '@getpopsure/public-utility';
import classNames from 'classnames';

export const PriceLine = ({
  label,
  sublabel,
  price,
  minus = false,
  bold = false,
  className,
}: {
  label: string;
  sublabel?: string;
  price: number;
  minus?: boolean;
  bold?: boolean;
  className?: string;
}) => (
  <div className={`d-flex jc-between px24 mt16 ${className}`}>
    <p
      className={classNames({
        'p-p': !bold,
        'p-h3': bold,
      })}
    >
      {label}
      {sublabel && <span className="tc-grey-500"> - {sublabel}</span>}
    </p>

    <p
      className={classNames({
        'p-h2': bold,
        'p-p': !bold,
      })}
    >
      {minus && '- '}
      {englishFormattedEuroCurrency(Math.round(price), true)}
    </p>
  </div>
);
